var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M42 78C22.2 78 6 61.8 6 42C6 22.2 22.2 6 42 6C61.8 6 78 22.2 78 42C78 61.8 61.8 78 42 78ZM42 12C25.5 12 12 25.5 12 42C12 58.5 25.5 72 42 72C58.5 72 72 58.5 72 42C72 25.5 58.5 12 42 12Z",
    fill: "#7A7B93"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M42 24C40.2 24 39 22.8 39 21C39 19.2 40.2 18 42 18C43.8 18 45 19.2 45 21C45 22.8 43.8 24 42 24ZM42 66C40.2 66 39 64.8 39 63V33C39 31.2 40.2 30 42 30C43.8 30 45 31.2 45 33V63C45 64.8 43.8 66 42 66Z",
    fill: "#04BA96"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/InfoIcon.815a4a64cd013c2f391aad962b0c779e.svg";
export { ForwardRef as ReactComponent };